import { Box, HStack } from '@web/components/atoms/Layout'
import { FundraiserProfile as FundraiserProfileProps, FundraiserProfileSubcomponents } from '@web/graphql-components'
import { pickPalette, SubComponentProps } from '../utils'
import { Avatar } from '@web/components/atoms/Avatar'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { DEFAULT_FUNDRAISER_PROFILE } from '../default'

export const DEFAULT_BIO = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 

Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 

Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. `

const FundraiserProfile = ({
  SubComponent,
  id,
  subComponents,
  styles,
  mobileStyles,
  avatarUrl,
  name,
  ...rest
}: FundraiserProfileProps & {
  avatarUrl?: string
  name?: string
  SubComponent: React.FC<SubComponentProps>
  isLoading?: boolean
}) => {
  const components = subComponents as FundraiserProfileSubcomponents
  const backgroundColor = useColorWithOpacity(
    styles?.backgroundColor,
    styles?.backgroundColorOpacity,
    DEFAULT_FUNDRAISER_PROFILE.styles.backgroundColor,
  )

  return (
    <Box
      w="100%"
      className="c-component-wrapper"
      bgColor={backgroundColor}
      borderRadius={`${styles?.borderRadius}px`}
      css={{
        p: mobileStyles?.padding,
        '& .c-profile__image': {
          flex: '0 0 auto',
        },
        '& .c-profile__image--desktop': {
          display: 'none',
        },
        '& .c-profile__image--mobile': {
          display: mobileStyles?.hasProfileImage ? 'block' : 'none',
        },
        '& .c-profile__social-share--desktop': {
          display: 'none',
        },
        '& .c-profile__social-share--mobile': {
          display: mobileStyles?.hasSocialShare ? 'block' : 'none',
        },
        '@container page (min-width: 901px)': {
          p: styles?.padding,
          '& .c-profile__image--mobile': {
            display: 'none',
          },
          '& .c-profile__image--desktop': {
            display: styles?.hasProfileImage ? 'block' : 'none',
          },
          '& .c-profile__social-share--desktop': {
            display: styles?.hasSocialShare ? 'block' : 'none',
          },
          '& .c-profile__social-share--mobile': {
            display: 'none',
          },
        },
      }}
    >
      <HStack w="100%" gap="24px" alignItems="end">
        <Box w="200px" h="200px" className="c-profile__image c-profile__image--desktop">
          <Avatar
            src={avatarUrl}
            name={name}
            size="full"
            fontSize="5xl"
            colorPalette={pickPalette(name ?? 'A')}
            shape={styles?.profileImageShape}
          />
        </Box>
        <Box w="100px" h="100px" className="c-profile__image c-profile__image--mobile">
          <Avatar
            src={avatarUrl}
            name={name}
            size="full"
            fontSize="3xl"
            colorPalette={pickPalette(name ?? 'A')}
            shape={styles?.profileImageShape}
          />
        </Box>
        <Box>
          <SubComponent {...rest} id={components.profileName} name="Profile Name" parentId={id} />
          {components.socialShare && (
            <Box className="c-profile__social-share--desktop" w="100%">
              <SubComponent {...rest} id={components.socialShare} name="Social Share" parentId={id} />
            </Box>
          )}
        </Box>
      </HStack>
      {components.socialShare && (
        <Box className="c-profile__social-share--mobile" w="fit-content" margin="0 auto">
          <SubComponent {...rest} id={components.socialShare} name="Social Share" parentId={id} />
        </Box>
      )}
    </Box>
  )
}

export default FundraiserProfile
